import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireCore } from '../node_modules/.pnpm/highlight.js@11.11.1/node_modules/highlight.js/lib/core.js';

var coreExports = /*@__PURE__*/ requireCore();
const HighlightJS = /*@__PURE__*/getDefaultExportFromCjs(coreExports);

export { HighlightJS as default };
//# sourceMappingURL=core.js.map
